import api from "../service/deca.service";
import apiDocumento from "../components/documentos/service/documento.service";
import apiCamposDinamicos from "../components/camposDinamicos/service/camposDinamicos.service";
import apiFileManager from "@/modules/common/app/helpers/fileManager-service";
import * as types from "./deca.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";

//Actions
import decaActions from "./deca.actions";
import solicitcaoActions from "../components/solicitacao/store/solicitacao.actions";
import atividadeActions from "../components/atividades/store/atividade.actions";
import historicoActions from "../components/historico/store/historico.actions";
import dadosCadastraisActions from "../components/dadosCadastrais/store/dadosCadastrais.actions";
import dadosSolicitanteActions from "../components/dadosSolicitante/store/dadosSolicitante.actions";
import socioActions from "../components/socio/store/socio.actions";
import solicitacaoActions from "../components/solicitacao/store/solicitacao.actions";
import solicitacaoSelectors from "../components/solicitacao/store/solicitacao.selectors";
import cnaeActions from "../components/cnae/store/cnae.actions";
import camposDinamicosActions from "../components/camposDinamicos/store/camposDinamicos.actions";
import camposDinamicosSelectors from "../components/camposDinamicos/store/camposDinamicos.selectors";
import enderecoCobrancaActions from "../components/enderecoCobranca/store/enderecoCobranca.actions";
import enderecoPrincipalActions from "../components/enderecoPrincipal/store/enderecoPrincipal.actions";
import documentoActions from "../components/documentos/store/documento.actions";

import focusHelper from "@common/helpers/focus.helper";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.DECASOLICITACAO_POST, save);
  yield takeEvery(types.DECASOLICITACAO_GET, getById);
  yield takeEvery(types.DECASOLICITACAO_PUT, update);
  yield takeEvery(types.DECASOLICITACAO_DELETE, remove);
  yield takeEvery(
    types.DECASOLICITACAO_VALIDAR_TIPO_EMPRESA,
    validarTipoEmpresa
  );
  yield takeEvery(types.PARAMETRO_GET, getParametro);
  yield takeEvery(types.SOLICITACAO_GET, getDadosSolicitacao);
  yield takeEvery(types.DECASOLICITACAO_LOADGRUPO, loadComboGrupo);
  yield takeEvery(types.DECASOLICITACAO_GETMANUAL, getManual);
}

function* getManual() {
  const response = yield call(api.getManual);

  const { NomeArquivo } = response.data;

  yield call(apiFileManager.downloadManual, 21, NomeArquivo);
}

function* getById(action) {
  yield put(decaActions.setReducarLoadDeca(1));

  const { payload } = action;

  const result = yield call(api.getById, payload.id);

  const { data } = result;

  yield put(
    solicitacaoActions.setSolicitacao({
      Numero: data.Numero,
      CpfCnpjSolicitacao: data.CpfCnpjSolicitacao,
      TipoSolicitacao:
        payload.prefix == "R"
          ? data.TipoSolicitacaoDescricao
          : data.TipoSolicitacao,
      TipoSolicitacaoNumero: data.TipoSolicitacao,
      CCM: data.Ccm,
      itensComboboxCCM: [{ Valor: data.Ccm, Texto: data.Ccm }],
      SituacaoSolicitacao: data.SituacaoSolicitacao,
      SituacaoSolicitacaoDescricao: data.SituacaoSolicitacaoDescricao,
      DescricaoSolicitacao: data.DescricaoSolicitacao,
    })
  );

  yield put(
    dadosCadastraisActions.setDadosCadastrais({
      NomeCadastral: data.NomeSolicitacao,
      NomeFantasiaCadastral: data.NomeFantasiaSolicitacao,
      EmailCadastral: data.EmailSolicitacao,
      RgIeCadastral: data.RgIeSolicitacao,
      TelefoneCadastral: data.TelefoneSolicitacao,
      CelularCadastral: data.CelularSolicitacao,
      DataNascimentoCadastral: data.DataNascimentoSolicitacao,
      DataAberturaCadastral: data.DataAberturaSolicitacao,
      RegimeTributacaoErrada: data.RegimeTributacaoErrada,
      RegimeTributacaoSolicitacaoDescricao:
        data.RegimeTributacaoSolicitacaoDescricao,
      RegimeTributacaoCadastral: data.RegimeTributacaoSolicitacao,
      DescricaoAtividade: data.DescricaoAtividade,
      Contador: data.Contador,
      EmailContadorCadastral: data.EmailContador,
      DataOcorrencia: data.DataOcorrencia,
      IdGrupo: data.IdGrupo,
    })
  );

  if (data.Anexo) {
    let anexosCustomizado = data.Anexo.filter((item) => {
      return item.TipoAnexo.Customizado == true;
    });

    let anexos = data.Anexo.filter((item) => {
      return item.TipoAnexo.Customizado == false;
    });

    if (anexosCustomizado.length) {
      yield put(documentoActions.setAnexoCustomizado(anexosCustomizado));
    }

    if (anexos.length) {
      yield put(documentoActions.setAnexo(anexos));
    }
  }

  if (data.Caracteristica) {
    yield put(camposDinamicosActions.setCamposDinamicos(data.Caracteristica));
  }

  if (data.CpfCnpjSolicitante) {
    yield put(
      dadosSolicitanteActions.setSolicitante({
        CpfCnpjSolicitante: data.CpfCnpjSolicitante,
        NomeSolicitante: data.NomeSolicitante,
        EmailSolicitante: data.EmailSolicitante,
        RgIeSolicitante: data.RgIeSolicitante,
        TelefoneSolicitante: data.TelefoneSolicitante,
        CelularSolicitante: data.CelularSolicitante,
        EnderecoSolicitante: data.EnderecoSolicitante,
      })
    );
  }

  if (data.Socio) {
    let arraySocioIdentificador = data.Socio.map((x, index) => {
      return { ...x, IdIdentificador: index };
    });

    yield put(socioActions.setStateListSocio(arraySocioIdentificador));
  }

  yield put(
    enderecoCobrancaActions.setEnderecoCobranca(
      data.EnderecoCobrancaSolicitacao
    )
  );

  yield put(
    enderecoPrincipalActions.setEnderecoPrincipal(
      data.EnderecoPrincipalSolicitacao
    )
  );

  if (data.Atividade) yield put(atividadeActions.setAtividade(data.Atividade));

  if (data.Socio) {
    let arraySocioIdentificador = data.Socio.map((x, index) => {
      return { ...x, IdIdentificador: index };
    });

    yield put(socioActions.setStateListSocio(arraySocioIdentificador));
  }

  if (data.Cnae) yield put(cnaeActions.setCnae(data.Cnae));

  if (data.Historico) yield put(historicoActions.setHistorico(data.Historico));

  yield put(formActions.gridReload());

  yield put(decaActions.setReducarLoadDeca(0));
}

function* getDadosSolicitacao(action) {
  const { payload } = action;
  yield put(decaActions.setReducarLoadDeca(1));

  yield put(solicitacaoActions.setCCMTipoSolicitacao(payload));

  yield put(solicitacaoActions.setCCMTipoSolicitacao(payload));
  yield put(
    documentoActions.getAnexo({
      cpfcnpj: payload.CpfCnpjSolicitacao,
      tipo: payload.TipoSolicitacao,
    })
  );

  const data = payload;

  yield put(
    solicitacaoActions.setSolicitacao({
      SituacaoSolicitacao: data.SituacaoSolicitacao,
      SituacaoSolicitacaoDescricao: data.SituacaoSolicitacaoDescricao,
      DescricaoSolicitacao: data.DescricaoSolicitacao,
    })
  );

  yield put(
    dadosCadastraisActions.setDadosCadastrais({
      NomeCadastral: data.NomeSolicitacao,
      NomeFantasiaCadastral: data.NomeFantasiaSolicitacao,
      EmailCadastral: data.EmailSolicitacao,
      RgIeCadastral: data.RgIeSolicitacao,
      TelefoneCadastral: data.TelefoneSolicitacao,
      CelularCadastral: data.CelularSolicitacao,
      DataNascimentoCadastral: data.DataNascimentoSolicitacao,
      DataAberturaCadastral: data.DataAberturaSolicitacao,
      RegimeTributacaoErrada: data.RegimeTributacaoErrada,
      RegimeTributacaoSolicitacaoDescricao:
        data.RegimeTributacaoSolicitacaoDescricao,
      RegimeTributacaoCadastral: data.RegimeTributacaoSolicitacao,
      Contador: data.Contador,
      EmailContadorCadastral: data.EmailContador,
      IdGrupo: data.IdGrupo,
      DescricaoAtividade: data.DescricaoAtividade,
    })
  );

  if (data.Caracteristica) {
    yield put(camposDinamicosActions.setCamposDinamicos(data.Caracteristica));
  }

  if (data.CpfCnpjSolicitante) {
    yield put(
      dadosSolicitanteActions.setSolicitante({
        CpfCnpjSolicitante: data.CpfCnpjSolicitante,
        NomeSolicitante: data.NomeSolicitante,
        EmailSolicitante: data.EmailSolicitante,
        RgIeSolicitante: data.RgIeSolicitante,
        TelefoneSolicitante: data.TelefoneSolicitante,
        CelularSolicitante: data.CelularSolicitante,
        EnderecoSolicitante: data.EnderecoSolicitante,
      })
    );
  }

  yield put(
    enderecoCobrancaActions.setEnderecoCobranca(
      data.EnderecoCobrancaSolicitacao
    )
  );

  yield put(
    enderecoPrincipalActions.setEnderecoPrincipal(
      data.EnderecoPrincipalSolicitacao
    )
  );

  if (data.Atividade) yield put(atividadeActions.setAtividade(data.Atividade));

  if (data.Socio) {
    let arraySocioIdentificador = data.Socio.map((x, index) => {
      return { ...x, IdIdentificador: index };
    });

    yield put(socioActions.setStateListSocio(arraySocioIdentificador));
  }

  if (data.Cnae) yield put(cnaeActions.setCnae(data.Cnae));

  if (data.Historico) yield put(historicoActions.setHistorico(data.Historico));

  yield put(formActions.gridReload());
  yield put(decaActions.setReducarLoadDeca(0));
}

function* save(action) {
  const { payload } = action;

  const result = yield call(api.save, payload);
  yield put(
    formActions.redirect("deca.comprovantesolicitacao", { id: result.data })
  );
  yield put(formActions.inserted());
}

function* update(action) {
  const { payload } = action;

  yield call(api.update, payload);
  yield put(formActions.updated());
  yield put(formActions.redirect("deca"));
}

function* remove(action) {
  const { payload } = action;

  yield call(api.remove, payload);
  yield put(formActions.deleted());
  yield put(formActions.gridReload());
}

function* validarTipoEmpresa(action) {
  const { payload } = action;

  try {
    let replaceMaskcpfCnpj = payload.replace(/[\._/-]/g, "").trim();
    let qtdCpfCnpj = replaceMaskcpfCnpj.length;

    if (qtdCpfCnpj == 11 || qtdCpfCnpj == 14) {
      const response = yield call(api.solicitacao, payload);

      if (!response.data || response.data.length < 1) {
        yield put(solicitcaoActions.setCCMTipoSolicitacao("", ""));
      } else {
        let comboBoxCCM = response.data.map((item) => {
          return { Valor: item, Texto: item };
        });
        yield put(solicitcaoActions.setComboboxCCM(comboBoxCCM, payload));
      }

      yield put(solicitcaoActions.disableTipoSolicitacao(false));
      yield put(solicitcaoActions.setCpfCnpjSolicitacao(payload));
      focusHelper.focus("TipoSolicitacao");
    } else {
      yield put(solicitacaoActions.resetForm("", "", true, ""));
      yield _alert.errorPromise("CPF/CNPJ inválido.");
      focusHelper.focus("CpfCnpjSolicitacao");
    }
  } catch (e) {
    yield put(solicitcaoActions.disableTipoSolicitacao(true));
    yield put(solicitacaoActions.resetForm("", "", true));
    return;
  }
}

function* loadComboGrupo() {
  const responseGrupo = yield call(api.getComboGrupo);
  yield put(decaActions.setComboGrupo(responseGrupo));
}

function* getParametro(action) {
  const { payload } = action;

  const result = yield call(api.getParametro, payload);
  yield put(decaActions.setParametro(result.data));

  let permiteDecaComEnderecoFora = result.data.find((parametro) => {
    return parametro.Nome == "PermitirDecaComEnderecoFora";
  });

  let somenteEnderecoSede = permiteDecaComEnderecoFora.Valor == "N";
  yield put(decaActions.setSomenteEnderecoSede(somenteEnderecoSede));
}
